import { createContext, useContext } from "react"

const BackgroundColorContext = createContext("white")
export const useBgColorContext = () => useContext(BackgroundColorContext)

export default BackgroundColorContext
